/* eslint-disable max-classes-per-file */
export class HostMessageControllerError extends Error {
  constructor(message) {
    super(message);
    this.name = 'TokenInvalidError';
  }
}

export class TokenRefreshTimeoutError extends HostMessageControllerError {
  constructor(message) {
    super(message);
    this.name = 'TokenRefreshTimeoutError';
  }
}

export class InvalidTokenError extends HostMessageControllerError {
  constructor(message) {
    super(message);
    this.name = 'InvalidTokenError';
  }
}
